import template from './index.jst';
import './index.styl';
import { ContactUsCoreView } from '../../../../../core/views';

export default class ContactUsView extends ContactUsCoreView {
	get template() {
		return template;
	}

	get className() {
		return "help-page contact-us-page";
	}

	get file_name() {
		return 'nrl';
	}
	get var_name() {
		return 'contact_us';
	}

	get users_name() {
		const user = JSON.parse(localStorage.getItem('user'));
		return (user && user.firstname) || '';
	}

	get users_email() {
		const user = JSON.parse(localStorage.getItem('user'));
		return (user && user.email) || '';
	}

	ui() {
		return {
			click_contact_us: '.js-contact-us',
		}
	}

	events() {
		return {
			'click @ui.click_contact_us': 'handleContactUsClick',
		}
	}

	handleContactUsClick() {
		if (window.zE) {
			window.zE.identify({
				name: this.users_name,
				email: this.users_email,
			});
			window.zE.activate();
		}
	}
}